<template>
  <v-container class="mt-16" grid-list-xl>
    <v-layout row wrap class="mt-5 mb-5">
      <v-flex xs12 text-xs-center>
        <h2 class="pretopia-head-font pretopia-display-1">{{ newsItem.title }}</h2>
      </v-flex>
      <v-flex xs12 sm6>
        <h3 class="mt-3 mb-4" v-html="newsItem.subtitle"></h3>
        <div v-html="newsItem.text"></div>
      </v-flex>
      <v-flex xs12 sm6>
        <v-carousel
          v-model="newsImageModel"
          :show-arrows="newsItem.newsimages && newsItem.newsimages.length > 1"
          :cycle="newsItem.newsimages && newsItem.newsimages.length > 1"
          :hide-delimiters="true"
          show-arrows-on-hover
        >
          <v-carousel-item
            v-for="(img, i) in newsItem.newsimages"
            :key="i"
            :src="'/storage/news/' + newsItem['id'] + '/' + img['name']"
            contain
          >
          </v-carousel-item>
        </v-carousel>
      </v-flex>
    </v-layout>

    <v-divider class="mb-5"></v-divider>

    <v-layout v-for="item in allNewsItems" :key="item.id">
      <v-flex xs3 md2>
        <v-img
          :src="getImageUrl(item)"
          class="pointer"
          v-if="item.newsimages && item.newsimages.length > 0"
          @click="redirectToNews(item)"
        ></v-img>
      </v-flex>
      <v-flex xs9 md10>
        <h3 class="pointer pretopia-head-font mb-3" @click="redirectToNews(item)">{{ item.title }}</h3>
        <div v-html="item.subtitle"></div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapStores } from 'pinia';
import { useNewsStore } from '../../stores/NewsStore';
import { isSwedishLocale } from '../../services/locale.service';

export default {
  data() {
    return {
      newsItem: { meta: {} },
      allNewsItems: [],
      newsImageModel: 0,
    };
  },

  watch: {
    // call again the method if the route changes
    $route: 'fetchNews',
  },

  computed: {
    ...mapStores(useNewsStore),

    image() {
      return '/storage/news/' + this.newsItem.id + '/' + this.newsItem.image_name;
    },
  },

  async created() {
    window.scrollTo(0, 0);
    const query = this.$route.query;
    const previewSwedish = query.preview && query.preview === 'true';
    const previewEnglish = query.previewenglish && query.previewenglish === 'true';
    const preview = previewSwedish || previewEnglish;
    const previewLanguage = !preview ? null : previewSwedish ? 'sv' : 'en';

    await this.loadNews(preview, previewLanguage);
  },

  methods: {
    getImageUrl(item) {
      if (item.newsimages && item.newsimages.length > 0) {
        return '/storage/news/' + item.id + '/' + item.newsimages[0]['thumb_name'];
      }
      return '';
    },

    async fetchNews() {
      await this.loadNews(false);

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },

    async loadNews(preview, previewLanguage) {
      const slug = this.$route.params.slug;

      await this.newsStore.loadAll(preview);
      this.allNewsItems = this.newsStore.allExcept(slug, previewLanguage);
      this.newsItem = this.newsStore.getBySlug(slug, previewLanguage);
      this.updateMetaInfo();
    },

    redirectToNews(item) {
      const slug = isSwedishLocale() ? item.slug : item.slug_eng;
      this.$router.push(`/news/${slug}`);
    },

    updateMetaInfo() {
      const defaultDescription =
        'Bildbank för dig som är frilansskribent eller arbetar på redaktion kan du här snabbt och enkelt söka efter bilder från leverantörer inom hem, inredning och trädgård.';
      const title = document.head.querySelector('title');
      const metaDescription = document.head.querySelector('meta[name=description]');
      const metaKeywords = document.head.querySelector('meta[name=keywords]');

      if (!title) {
        const titleNode = document.createElement('title');
        titleNode.appendChild(document.createTextNode(this.newsItem.title));
        document.head.appendChild(titleNode);
      } else {
        title.innerText = this.newsItem.title;
      }

      if (!metaDescription) {
        document.head.appendChild(
          document.createElement('meta', {
            name: 'description',
            content: this.newsItem.meta.description || defaultDescription,
          })
        );
      } else {
        metaDescription.setAttribute('content', this.newsItem.meta.description || defaultDescription);
      }

      if (!metaKeywords) {
        document.head.appendChild(
          document.createElement('meta', { name: 'keywords', content: this.newsItem.meta.keywords || '' })
        );
      } else {
        metaKeywords.setAttribute('content', this.newsItem.meta.keywords || '');
      }
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
